/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Phase_InterviewInputs */

const en_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const de_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const fr_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretien`)
};

const es_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrevista`)
};

const it_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colloquio`)
};

const nl_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegesprek`)
};

const pl_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowa`)
};

const fi_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastattelu`)
};

const da_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const sv_nav_phase_interview = /** @type {(inputs: Nav_Phase_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervju`)
};

/**
* | output |
* | --- |
* | "Interview" |
*
* @param {Nav_Phase_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_phase_interview = /** @type {((inputs?: Nav_Phase_InterviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Phase_InterviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_phase_interview(inputs)
	if (locale === "fr") return fr_nav_phase_interview(inputs)
	if (locale === "es") return es_nav_phase_interview(inputs)
	if (locale === "it") return it_nav_phase_interview(inputs)
	if (locale === "nl") return nl_nav_phase_interview(inputs)
	if (locale === "pl") return pl_nav_phase_interview(inputs)
	if (locale === "fi") return fi_nav_phase_interview(inputs)
	if (locale === "da") return da_nav_phase_interview(inputs)
	if (locale === "sv") return sv_nav_phase_interview(inputs)
	return en_nav_phase_interview(inputs)
});